import mitt from 'mitt'

const bus = mitt()

const _emit = bus.emit.bind(bus)

bus.emit = (type, a, b) => {
  if (type === 'notification') {
    // a = message, b = options
    const payload = { message: a, options: b }
    return _emit(type, payload)
  }
  return _emit(type, a, b)
}

export default bus
